import { TS_Item }              from '../TravelSeller/Models/TS_Item';
import { BookingItemInterface } from './BookingItemInterface';

export class Item extends TS_Item implements BookingItemInterface {}
